import { ChangeEventHandler, useMemo } from 'react';

export type OptionProps = {
  title: string;
  value: string | number | readonly string[] | undefined;
};

type DropdownSelectProps = {
  className?: string;
  initialOption?: OptionProps;
  customOptions?: OptionProps[];
  selectedValue?: OptionProps | undefined;
  optionValues: OptionProps[];
  placeholder?: string;
  onChange?: ChangeEventHandler<HTMLSelectElement> | undefined;
};

const defaultClassName = `
  min-w-48 border-2 bg-white px-1 py-px
  text-sm text-black shadow-inner
  border-b-gray-300 border-l-gray-700
  border-r-gray-300 border-t-gray-700
`;

const DropdownSelect = (props: DropdownSelectProps) => {
  const allOptions = useMemo(
    () => [...(props.customOptions ?? []), ...props.optionValues],
    [props.customOptions, props.optionValues]
  );

  return (
    <select
      className={props.className ?? defaultClassName}
      onChange={props.onChange ?? (() => undefined)}
      value={props.selectedValue?.value ?? ''}
    >
      {props.placeholder && <option value="">{props.placeholder}</option>}
      {props.initialOption && (
        <option value={props.initialOption.value}>{props.initialOption.title}</option>
      )}
      {allOptions.map((value, index) => (
        <option value={value.value} key={value.title + String(index)}>
          {value.title}
        </option>
      ))}
    </select>
  );
};

export default DropdownSelect;
